import React from "react";
import "./Review.css";
import reviews, { overallRating, totalReviews } from "../../data/reviews";

const Star = ({ filled }) => (
  <svg viewBox="0 0 24 24" className="rv-star" width="17" height="17" aria-hidden="true">
    <path
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      fill={filled ? "#fbbf24" : "none"}
      stroke="#fbbf24"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const Stars = ({ rating }) => (
  <span className="rv-stars">
    {[1, 2, 3, 4, 5].map((n) => <Star key={n} filled={n <= rating} />)}
  </span>
);

const GoogleG = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
  </svg>
);

const Verified = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" className="rv-verified" aria-hidden="true">
    <path fill="#4285F4" d="M12 1l2.4 1.8 3 .2.2 3L19.4 9 21 12l-1.6 3-.2 3-3 .2L12 21l-2.4-1.8-3-.2-.2-3L4.6 15 3 12l1.8-2.4.2-3 3-.2L12 1z" />
    <path fill="#fff" d="M10.6 14.6L8 12l1.1-1.1 1.5 1.5 3.3-3.3L15 10.2z" />
  </svg>
);

const Testimonials = () => (
  <div className="full-width-wrapper">
    <section className="testimonials-section">
      <div className="testimonial-left">
        <p className="testimonial-header">TESTIMONIALS</p>
        <h2 className="testimonial-title">
          PEOPLE<span className="italic-red"> TALK</span>
          <br />
          <span className="italic-red">ABOUT</span> US
        </h2>

        <div className="rv-badge">
          <GoogleG />
          <div className="rv-badge-text">
            <div className="rv-badge-row">
              <span className="rv-badge-rating">{overallRating.toFixed(1)}</span>
              <Stars rating={Math.round(overallRating)} />
            </div>
            <span className="rv-badge-count">Based on {totalReviews}+ Google reviews</span>
          </div>
        </div>
      </div>

      <div className="reviews-grid">
        {reviews.map((r, i) => (
          <article className="review-card" key={i}>
            <div className="review-bubble">
              <Stars rating={r.rating} />
              <p className="review-text">{r.text}</p>
            </div>
            <div className="review-author">
              <span className="review-avatar"><GoogleG /></span>
              <div className="review-author-info">
                <strong>{r.name} <Verified /></strong>
                {r.date && <span>{r.date}</span>}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  </div>
);

export default Testimonials;
